import { render, staticRenderFns } from "./CartButtonDesktop.vue?vue&type=template&id=49cf88d0&"
import script from "./CartButtonDesktop.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CartButtonDesktop.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cf88d0')) {
      api.createRecord('49cf88d0', component.options)
    } else {
      api.reload('49cf88d0', component.options)
    }
    module.hot.accept("./CartButtonDesktop.vue?vue&type=template&id=49cf88d0&", function () {
      api.rerender('49cf88d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/AnalysisCard/components/CartButtonDesktop.vue"
export default component.exports